import { Checkbox, CheckboxProps } from '@mui/material'

interface Props extends CheckboxProps {
    className?: string
}
const CustomCheckbox = ({ className, ...restOfProps }: Props) => {
    return (
        <Checkbox
            className={`-:text-primary ${className}`}
            {...restOfProps}
        />
    )
}

export default CustomCheckbox
